import './Releases.css';
import React from 'react';

const Releases: React.FC = () => {
  return <main>
  <section id="release-banner">
      <div className="release-banner">
        <div className="overlay"></div>
        <div className="release-img">
          <img src="/images/global/release-cover.png" alt="" />
        </div>
        <div className="release-label">
          <p>ALBUM</p>
        </div>
        <div className="release-links">
          <a href="javascript:void(0);">
            <svg xmlns="http://www.w3.org/2000/svg" width="65" height="42" viewBox="0 0 65 42" fill="none">
              <path
                d="M4.35014 21.0632V33.5394C4.35014 34.0909 4.13106 34.6198 3.7411 35.0097C3.35115 35.3997 2.82225 35.6187 2.27077 35.6187C1.71929 35.6187 1.19039 35.3997 0.800438 35.0097C0.410482 34.6198 0.191406 34.0909 0.191406 33.5394V21.0632C0.191406 20.5117 0.410482 19.9828 0.800438 19.5929C1.19039 19.2029 1.71929 18.9838 2.27077 18.9838C2.82225 18.9838 3.35115 19.2029 3.7411 19.5929C4.13106 19.9828 4.35014 20.5117 4.35014 21.0632ZM10.5882 12.7457C10.0368 12.7457 9.50786 12.9648 9.1179 13.3548C8.72794 13.7447 8.50887 14.2736 8.50887 14.8251V39.7775C8.50887 40.329 8.72794 40.8578 9.1179 41.2478C9.50786 41.6378 10.0368 41.8568 10.5882 41.8568C11.1397 41.8568 11.6686 41.6378 12.0586 41.2478C12.4485 40.8578 12.6676 40.329 12.6676 39.7775V14.8251C12.6676 14.2736 12.4485 13.7447 12.0586 13.3548C11.6686 12.9648 11.1397 12.7457 10.5882 12.7457ZM18.9057 10.6664C18.3542 10.6664 17.8253 10.8854 17.4354 11.2754C17.0454 11.6653 16.8263 12.1942 16.8263 12.7457V39.7775C16.8263 40.329 17.0454 40.8578 17.4354 41.2478C17.8253 41.6378 18.3542 41.8568 18.9057 41.8568C19.4572 41.8568 19.9861 41.6378 20.376 41.2478C20.766 40.8578 20.9851 40.329 20.9851 39.7775V12.7457C20.9851 12.1942 20.766 11.6653 20.376 11.2754C19.9861 10.8854 19.4572 10.6664 18.9057 10.6664ZM27.2232 2.3489C26.6717 2.3489 26.1428 2.56797 25.7528 2.95793C25.3629 3.34789 25.1438 3.87678 25.1438 4.42826V39.7775C25.1438 40.329 25.3629 40.8578 25.7528 41.2478C26.1428 41.6378 26.6717 41.8568 27.2232 41.8568C27.7746 41.8568 28.3035 41.6378 28.6935 41.2478C29.0834 40.8578 29.3025 40.329 29.3025 39.7775V4.42826C29.3025 3.87678 29.0834 3.34789 28.6935 2.95793C28.3035 2.56797 27.7746 2.3489 27.2232 2.3489ZM56.0328 17.5127C55.1961 12.6848 52.6815 8.30747 48.9323 5.15276C45.1832 1.99805 40.4404 0.268622 35.5406 0.269532H34.5009C34.2252 0.269532 33.9607 0.379069 33.7658 0.574048C33.5708 0.769026 33.4613 1.03347 33.4613 1.30921V40.8172C33.4613 41.0929 33.5708 41.3573 33.7658 41.5523C33.9607 41.7473 34.2252 41.8568 34.5009 41.8568H51.9702C58.619 41.8568 64.2567 36.7312 64.6309 30.0928C64.7863 27.3411 64.0273 24.6153 62.4721 22.3399C60.917 20.0645 58.653 18.3673 56.0328 17.5127Z"
                fill="white"
              />
            </svg>
          </a>
          <a href="javascript:void(0);">
            <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" fill="none">
              <path
                d="M33 1.03125C15.3398 1.03125 1.03125 15.3398 1.03125 33C1.03125 50.6602 15.3398 64.9688 33 64.9688C50.6602 64.9688 64.9688 50.6602 64.9688 33C64.9688 15.3398 50.6602 1.03125 33 1.03125ZM39.2133 43.0676H15.8812L26.7996 22.9453H50.1316L39.2133 43.0676Z"
                fill="white"
              />
            </svg>
          </a>
          <a href="javascript:void(0);">
            <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.35693 33C2.35693 24.873 5.58537 17.0789 11.332 11.3323C17.0787 5.58561 24.8728 2.35718 32.9998 2.35718C41.1268 2.35718 48.9209 5.58561 54.6676 11.3323C60.4142 17.0789 63.6427 24.873 63.6427 33C63.6427 41.127 60.4142 48.9212 54.6676 54.6678C48.9209 60.4145 41.1268 63.6429 32.9998 63.6429C24.8728 63.6429 17.0787 60.4145 11.332 54.6678C5.58537 48.9212 2.35693 41.127 2.35693 33ZM24.3208 45.2289C28.8624 44.1652 33.6301 44.6669 37.8508 46.6526C38.2006 46.8182 38.5796 46.9133 38.9661 46.9324C39.3526 46.9516 39.7391 46.8944 40.1036 46.7642C40.468 46.6339 40.8032 46.4332 41.0901 46.1734C41.3769 45.9136 41.6098 45.5999 41.7754 45.2501C41.941 44.9003 42.0361 44.5213 42.0553 44.1348C42.0744 43.7483 42.0172 43.3618 41.887 42.9973C41.7568 42.6329 41.556 42.2977 41.2962 42.0108C41.0365 41.724 40.7227 41.4911 40.3729 41.3255C34.9477 38.7681 28.8172 38.1202 22.9772 39.4869C22.6002 39.5751 22.2442 39.7367 21.9297 39.9625C21.6151 40.1883 21.3481 40.4738 21.1439 40.8028C20.9397 41.1318 20.8022 41.4978 20.7395 41.8799C20.6767 42.2619 20.6898 42.6527 20.778 43.0297C20.8662 43.4067 21.0278 43.7627 21.2536 44.0772C21.4794 44.3918 21.7649 44.6588 22.0939 44.863C22.4229 45.0672 22.7889 45.2047 23.171 45.2674C23.5531 45.3302 23.9438 45.3171 24.3208 45.2289ZM29.0398 35.2582C26.6544 35.2582 24.3349 35.5363 22.1192 36.0596C21.7425 36.1484 21.352 36.1622 20.9699 36.1001C20.5879 36.038 20.2218 35.9013 19.8926 35.6978C19.5634 35.4942 19.2776 35.2278 19.0513 34.9137C18.8251 34.5997 18.6629 34.2442 18.5741 33.8675C18.4852 33.4907 18.4715 33.1002 18.5336 32.7182C18.5956 32.3361 18.7324 31.9701 18.9359 31.6409C19.1395 31.3117 19.4059 31.0258 19.7199 30.7996C20.034 30.5733 20.3895 30.4112 20.7662 30.3223C29.0258 28.3769 37.707 29.4086 45.2805 33.2358C45.973 33.5916 46.4965 34.207 46.7366 34.9476C46.9768 35.6882 46.914 36.4938 46.5621 37.1882C46.2102 37.8827 45.5977 38.4097 44.8585 38.654C44.1193 38.8983 43.3134 38.8402 42.6169 38.4922C38.4095 36.3588 33.7572 35.2507 29.0398 35.2582ZM19.8941 26.895C22.8908 26.1855 25.9602 25.8279 29.0398 25.8296C35.7152 25.8296 41.9947 27.4796 47.5009 30.4025C48.1917 30.7682 48.9995 30.8445 49.7466 30.6146C50.4936 30.3848 51.1188 29.8675 51.4845 29.1768C51.8502 28.486 51.9265 27.6782 51.6967 26.9311C51.4668 26.184 50.9496 25.5589 50.2588 25.1932C43.724 21.7317 36.4395 19.9268 29.0445 19.9368C25.5045 19.9349 21.9763 20.3463 18.5316 21.1625C18.1505 21.2473 17.79 21.407 17.4711 21.6324C17.1522 21.8578 16.8813 22.1443 16.6741 22.4753C16.4669 22.8063 16.3276 23.1752 16.2643 23.5605C16.2009 23.9458 16.2148 24.3399 16.3051 24.7198C16.3954 25.0997 16.5603 25.4579 16.7902 25.7735C17.0202 26.0892 17.3105 26.3559 17.6445 26.5583C17.9784 26.7607 18.3493 26.8947 18.7355 26.9525C19.1217 27.0103 19.5155 26.9908 19.8941 26.895Z"
                fill="white"
              />
            </svg>
          </a>
        </div>
        <div className="release-name">
          <p>Fluctt</p>
          <span className="release-name-label">“Late Night Techno”</span>
        </div>
      </div>
  </section>
  <section id="release-archive">
      <div className="container">
          <div className="release-archive-name flex gap-2">
              <p>Release archive</p>
              
          </div>
          <div className="release-archive-gallery">
              <div className="release-archive-gallery-item">
                  <div className="top-action">
                      <div className="top-label">
                          <span>ALBUM</span>
                      </div>
                      <div className="top-media">
                          <a href="">                              
                          </a>
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                      </div>
                  </div>
                  <div className="release-archive-gallery-img">
                      <img src="/images/global/archive-1.png" alt=""/>
                  </div>                            
                  <div className="bottom-action album-name">
                      <span>
                          <p className="flex flex flex--direction__column">your friend Dao<span>missing you so much</span> </p>
                              <div className='link-button'>
                                <button> 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                        <path d="M6.33333 1.5H30.5V25.6667M30.5 1.5L1.5 30.5L30.5 1.5Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                              </div>
                      </span>
                  </div>
              </div>
              <div className="release-archive-gallery-item">
                  <div className="top-action">
                      <div className="top-label">
                          <span>ALBUM</span>
                      </div>
                      <div className="top-media">
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                      </div>
                  </div>
                  <div className="release-archive-gallery-img">
                      <img src="/images/global/archive-2.png" alt=""/>
                  </div>                            
                  <div className="bottom-action album-name">
                      <span>
                          <p className="flex flex flex--direction__column">your friend Dao<span>missing you so much</span> </p>
                          <div className='link-button'>
                              <button > 
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path d="M6.33333 1.5H30.5V25.6667M30.5 1.5L1.5 30.5L30.5 1.5Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </button>
                          </div>
                      </span>
                  </div>
              </div>
              <div className="release-archive-gallery-item">
                  <div className="top-action">
                      <div className="top-label">
                          <span>ALBUM</span>
                      </div>
                      <div className="top-media">
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                      </div>
                  </div>
                  <div className="release-archive-gallery-img">
                      <img src="/images/global/archive-3.png" alt=""/>
                  </div>                            
                  <div className="bottom-action album-name">
                      <span>
                          <p className="flex flex flex--direction__column">your friend Dao<span>missing you so much</span> </p>
                          <div className='link-button'>
                              <button > 
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path d="M6.33333 1.5H30.5V25.6667M30.5 1.5L1.5 30.5L30.5 1.5Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </button>
                          </div>
                      </span>
                  </div>
              </div>
              <div className="release-archive-gallery-item">
                  <div className="top-action">
                      <div className="top-label">
                          <span>ALBUM</span>
                      </div>
                      <div className="top-media">
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                      </div>
                  </div>
                  <div className="release-archive-gallery-img">
                      <img src="/images/global/archive-4.png" alt=""/>
                  </div>                            
                  <div className="bottom-action album-name">
                      <span>
                          <p className="flex flex flex--direction__column">your friend Dao<span>missing you so much</span> </p>
                          <div className='link-button'>
                              <button > 
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path d="M6.33333 1.5H30.5V25.6667M30.5 1.5L1.5 30.5L30.5 1.5Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </button>
                          </div>
                      </span>
                  </div>
              </div>
              <div className="release-archive-gallery-item">
                  <div className="top-action">
                      <div className="top-label">
                          <span>ALBUM</span>
                      </div>
                      <div className="top-media">
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                      </div>
                  </div>
                  <div className="release-archive-gallery-img">
                      <img src="/images/global/archive-5.png" alt=""/>
                  </div>                            
                  <div className="bottom-action album-name">
                      <span>
                          <p className="flex flex flex--direction__column">your friend Dao<span>missing you so much</span> </p>
                          <div className='link-button'>
                              <button > 
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path d="M6.33333 1.5H30.5V25.6667M30.5 1.5L1.5 30.5L30.5 1.5Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </button>
                          </div>
                      </span>
                  </div>
              </div>
              <div className="release-archive-gallery-item">
                  <div className="top-action">
                      <div className="top-label">
                          <span>ALBUM</span>
                      </div>
                      <div className="top-media">
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                      </div>
                  </div>
                  <div className="release-archive-gallery-img">
                      <img src="/images/global/archive-6.png" alt=""/>
                  </div>                            
                  <div className="bottom-action album-name">
                      <span>
                          <p className="flex flex flex--direction__column">your friend Dao<span>missing you so much</span> </p>
                          <div className='link-button'>
                              <button > 
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path d="M6.33333 1.5H30.5V25.6667M30.5 1.5L1.5 30.5L30.5 1.5Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </button>
                          </div>
                      </span>
                  </div>
              </div>
              <div className="release-archive-gallery-item">
                  <div className="top-action">
                      <div className="top-label">
                          <span>ALBUM</span>
                      </div>
                      <div className="top-media">
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                      </div>
                  </div>
                  <div className="release-archive-gallery-img">
                      <img src="/images/global/archive-7.png" alt=""/>
                  </div>                            
                  <div className="bottom-action album-name">
                      <span>
                          <p className="flex flex flex--direction__column">your friend Dao<span>missing you so much</span> </p>
                          <div className='link-button'>
                              <button > 
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path d="M6.33333 1.5H30.5V25.6667M30.5 1.5L1.5 30.5L30.5 1.5Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </button>
                          </div>
                      </span>
                  </div>
              </div>
              <div className="release-archive-gallery-item">
                  <div className="top-action">
                      <div className="top-label">
                          <span>ALBUM</span>
                      </div>
                      <div className="top-media">
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                      </div>
                  </div>
                  <div className="release-archive-gallery-img">
                      <img src="/images/global/archive-8.png" alt=""/>
                  </div>                            
                  <div className="bottom-action album-name">
                      <span>
                          <p className="flex flex flex--direction__column">your friend Dao<span>missing you so much</span> </p>
                          <div className='link-button'>
                              <button > 
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path d="M6.33333 1.5H30.5V25.6667M30.5 1.5L1.5 30.5L30.5 1.5Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </button>
                          </div>
                      </span>
                  </div>
              </div>
              <div className="release-archive-gallery-item">
                  <div className="top-action">
                      <div className="top-label">
                          <span>ALBUM</span>
                      </div>
                      <div className="top-media">
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                          <a href="">
                          </a>
                      </div>
                  </div>
                  <div className="release-archive-gallery-img">
                      <img src="/images/global/archive-3.png" alt=""/>
                  </div>                            
                  <div className="bottom-action album-name">
                      <span>
                          <p className="flex flex flex--direction__column">your friend Dao<span>missing you so much</span> </p>
                          <div className='link-button'>
                              <button > 
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path d="M6.33333 1.5H30.5V25.6667M30.5 1.5L1.5 30.5L30.5 1.5Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </button>
                          </div>
                      </span>
                  </div>
              </div>                    
          </div>
      </div>            
  </section>
</main>;
};

export default Releases;
